import { useEffect } from 'react';

/**
 * useGatewayContinuityRedirect — Phase 4a UX repositioning.
 * Gateway (Continuity-tier) users are Continuity-first, not Premium-with-
 * padlocks. If they land on the Overview tab, quietly send them to their
 * real home — the Continuity System vault.
 */
export default function useGatewayContinuityRedirect(isGateway, activeTab, setActiveTab) {
  useEffect(() => {
    if (isGateway && activeTab === 'dashboard') setActiveTab('estate-vault');
  }, [isGateway, activeTab, setActiveTab]);
}
